import { Box } from '@mui/system';
import { setHoverDeparturePad } from 'actions/orderActions';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { bindTrigger } from 'material-ui-popup-state';
import React, { SyntheticEvent } from 'react';
import { selectHoverDeparturePad, selectPadStatusMap } from 'selectors/ordersSelector';
import typography from '../../../theme/typography';

import { selectPads } from 'selectors/liveAircraftSelectors';

export const DeparturePadTag = (props: { popupState: any; departurePadId: number }) => {

  const dispatch = useAppDispatch();

  const hoverDeparturePad = useAppSelector(selectHoverDeparturePad);
  const pads = useAppSelector(selectPads);
  const padStatusMap = useAppSelector(selectPadStatusMap);
  
  const click = (func: (event: SyntheticEvent<any>) => void) => (
    event: SyntheticEvent<any>
  ) => {
    func(event);
    event.stopPropagation();
  };
  
  const mouseEnterDeparturePad = () => {
    if (hoverDeparturePad === props.departurePadId) return;
    dispatch(setHoverDeparturePad(props.departurePadId));
  };
  
  const mouseExitDeparturePad = () => {
    if (hoverDeparturePad === null) return;
    dispatch(setHoverDeparturePad(null));
  };
  
  const isDeparturePadHovered =
    props.departurePadId !== null && props.departurePadId === hoverDeparturePad;

  // Get pad status from memoized selector - much more efficient
  const getPadStatus = (padId: number) => {
    return padStatusMap.get(padId) || { color: null, label: null, count: 0 };
  };

  const getPadNameById = (padId: number): string => {
    if (!padId || padId === null) return '';
    
    // Find the pad with matching ID
    const pad = pads.find(p => p.id == padId);
    if (pad) {
      console.log("DeparturePadTag - Found pad name:", pad.name, "for ID:", padId);
      return pad.name;
    } else {
      console.log("DeparturePadTag - No pad found for ID:", padId);
      return padId.toString();
    }
  };

  const getDeparturePadButtonText = (): string => {
    if (!props.departurePadId) {
      return 'Pad...';
    }
    if (props.departurePadId === null) {
      return 'None';
    }
    
    const padName = getPadNameById(props.departurePadId);
    return padName || props.departurePadId.toString();
  }
  
  const padStatus = getPadStatus(props.departurePadId);
  const statusColor = padStatus.color;

  return (
    <Box
      {...bindTrigger(props.popupState)}
      onClick={click(bindTrigger(props.popupState).onClick)}
      pl={0.5}
      display={'flex'}
      alignItems="center"
      justifyItems="center"
      onMouseEnter={mouseEnterDeparturePad}
      onMouseLeave={mouseExitDeparturePad}
      bgcolor={isDeparturePadHovered ? '#D9DBE9' : '#FFFFFF'}
      sx={{
        paddingRight: 1,
        height: 32,
        borderRadius: 1,
        border: `1px ${props.departurePadId ? 'solid' : 'dashed'} ${props.departurePadId ? '#14142B' : '#D9DBE9'}`
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <span className='font-semibold text-nowrap'
          style={{
            ...typography.body2,
            color: props.departurePadId ? '#14142B' : 'gray'
          }}
        >
          {getDeparturePadButtonText()}
        </span>
        {!!props.departurePadId && !!statusColor && (
          <Box
            sx={{
              width: 8,
              height: 8,
              backgroundColor: statusColor,
              borderRadius: '50%',
              border: '1px solid rgba(0,0,0,0.1)',
              flexShrink: 0
            }}
          />
        )}
      </Box>
    </Box>
  );
};
